import { SettingsStorageMixin } from "@/services/storage/storage-mixins/settings-storage-mixin";
import { StemSplitterSettingsField } from "@/services/storage/stem-splitter-session-storage";

export class StemSplitterSettingsStorageMixin extends SettingsStorageMixin<StemSplitterSettingsField> {
  protected setSettingsInternal(
    settings: any,
    value: any,
    field: StemSplitterSettingsField,
  ): void {
    if (field === "category") {
      if (!Array.isArray(settings[field])) {
        settings[field] = [];
      }

      settings[field] = [...settings[field], ...value];
    } else {
      settings[field] = value;
    }

    settings[field] = value;
  }
}
